import { useState, useEffect } from "react";
import { KineticText } from "../components/KineticText";
import { Reveal } from "../components/Reveal";
import { RichText } from "../components/RichText";
import { TextWithImage } from "../components/TextWithImage";
import { Footer } from "../components/Footer";
import { fetchSiteContent } from "../lib/api";
import { useLang } from "../context/LanguageContext";

export default function About() {
  const { t, L } = useLang();
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchSiteContent().then(setContent).catch((e) => { console.error("site content failed:", e); setContent({}); });
  }, []);

  const studioImg = (content && content.about_image) || "";
  const rawTitle = ((content && L(content, "about_title")) || "").trim();
  const titleLines = rawTitle ? rawTitle.split("\n").filter((l) => l.trim()) : [t("about_t1"), t("about_t2")];

  return (
    <main data-testid="about-page" className="min-h-screen">
      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pt-40 md:pt-52 pb-20">
        <p className="font-mono text-[11px] tracking-[0.4em] uppercase text-[var(--vsl-green)] mb-6">{t("about_eyebrow")}</p>
        {content ? (
          <KineticText lines={titleLines}
            className="font-display text-[13vw] md:text-[8vw] leading-[0.9] tracking-[-0.01em]" />
        ) : (
          <h1 aria-hidden className="font-display text-[13vw] md:text-[8vw] leading-[0.9] tracking-[-0.01em] opacity-0">
            {[t("about_t1"), t("about_t2")].map((l) => <span key={l} className="block">{l}</span>)}
          </h1>
        )}
      </section>

      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pb-24">
        <TextWithImage imageUrl={studioImg} width={content?.about_image_w} height={content?.about_image_h}
          caption={L(content, "about_caption")} testid="about-image">
          <Reveal>
            <RichText as="div" html={L(content, "about_intro")} testid="about-body"
              className="font-roboto text-base md:text-lg lg:text-xl font-light leading-relaxed whitespace-pre-line text-[var(--vsl-limestone)]" />
          </Reveal>
        </TextWithImage>
      </section>

      <Footer content={content} />
    </main>
  );
}
